import { LABELS } from '~/app/constants'

const FREQUENCY = 0.5
const MAX_NUM_LABELS = 10

/**
 *
 */
export default function mockLabelCounters() {
  const counters = []

  for (const label of LABELS) {
    let count = 0

    if (Math.random() < FREQUENCY) {
      count = Math.floor(Math.random() * MAX_NUM_LABELS) + 1
    }

    counters.push({ label: label.id, count })
  }

  return counters
}
